<template>
  <div>
    <div class="row">
      <div v-if="loading" class="col-md-12 text-center" style="margin-top:25%">
        <PulseLoader :loading="loading"></PulseLoader>
      </div>
    </div>
    <div v-if="!loading">
      <div class="row">
        <div class="col-md-12 col-sm-12">
          <div class>
            <div class="x_panel">
              <div class="row">
                <div class="col-md-2">
                  <div>
                    <div class="form-group">
                      <select v-model="formData.budget_year" name="budget_year" class="form-control">
                        <option v-for="year in years" :key="year" selected>{{year}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div>
                    <div class="form-group">
                      <select v-model="formData.budget_month" name="budget_month" class="form-control">
                        <option v-for="sMonth in month" :key="sMonth" selected :value="sMonth">{{sMonth}}</option>
                      </select>
                    </div>
                  </div>
                </div>
                <div class="col-md-2">
                  <div class="form-group">
                    <Select2 v-model="formData.budget_head_id" name="budget_head_id" :options="myOptions" placeholder="Select Budget Head"/>
                  </div>
                </div>
                <div class="col-md-1">
                  <div>
                    <div class="form-group">
                      <label></label>
                      <button title="Search Budget" class="btn btn-info btn-sm" @click="getData()">Search</button>
                    </div>
                  </div>
                </div>
                <div class="col-md-1"></div>
                <div class="col-md-4">
                  <button @click="goBack" class="btn btn-danger btn-sm float-right">Back <i class="fa fa-arrow-circle-o-right"></i></button>
                  <button @click="print('printArea','Budget Report')" class="btn btn-warning btn-sm float-right"><i class="fa fa-print"></i> Print</button>
                  <router-link to="budget-report" class="btn btn-info btn-sm float-right">Budget Report</router-link>

                </div>
              </div>
              <div class="clearfix"></div>
            </div>
          </div>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="x_title">
            <div class="clearfix"></div>
          </div>
        </div>
      </div>
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <div class="card">
              <div class="card-header text-center">
                <h5 class="text-center">{{vessel_name}}</h5>
                <p>Budget Variance of {{selectedMonth}} {{selectedYear}} </p>
              </div>
              <div class="card-body">
                <div class="table-responsive tableStyle">
                  <TableData :budgetInfoList="budgetInfoList" :createVarianceRemarks="createVarianceRemarks" :selectedMonth="selectedMonth" :selectedYear="selectedYear" :isEmpty="isEmpty"></TableData>
                  <div id="printArea" style="display: none">
                    <div style="text-align: center;line-height: 20px;">
                      <h2>{{ appName }}</h2>
                      <div class="font-weight-bold">{{vessel_name}}</div>
                      <div class="font-weight-bold">Budget Variance of {{selectedYear}}</div>
                      <p>Printing Date: {{new Date().toISOString().substring(0, 10)}}</p>
                      <TableData :budgetInfoList="budgetInfoList" :isEmpty="isEmpty" :isPrinting="true"></TableData>
                    </div>
                  </div>

                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Create purchase order Modal -->
    <div class="modal fade" id="budgetVarianceModal" tabindex="-1" role="dialog" aria-labelledby="budgetVarianceModalTitle" aria-hidden="true">
      <div class="modal-dialog w-25" role="document">
        <div class="modal-content">
          <form @submit="storeVarianceRemarks" action="#" method="POST">
            <div class="modal-header">
              <h5 class="modal-title" id="budgetVarianceModalTitle">Add {{budget_head_name}} Variance Remarks</h5>
              <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                <span aria-hidden="true">&times;</span>
              </button>
            </div>
            <div class="modal-body">
              <div class="row">
                <div class="col-12">
                  <div class="form-group">
                    <label>Variance Remarks<span class="text-danger">*</span></label>
                    <input v-model="budgetVarianceForm.remarks" type="text" name="remarks" class="form-control" placeholder="Enter Variance Remarks" autocomplete="off" required>
                  </div>
                </div>
                <div class="col-12">
                  <div class="form-group">
                    <label>Document</label>
                    <input @change="convertDocument" type="file" class="form-control" placeholder="Remarks" />
                  </div>
                </div>
              </div>
            </div>
            <div class="modal-footer">
              <button type="button" class="btn btn-secondary" data-dismiss="modal">Close</button>
              <button :disabled="disable" type="submit" class="btn btn-info">Submit</button>
            </div>
          </form>
        </div>
      </div>
    </div>
    <!-- Create purchase order Modal -->
  </div>

</template>

<script>
    import PulseLoader from "vue-spinner/src/PulseLoader.vue";
    import auth from "@/auth";
    import TableData from "./TableData.vue";
    import {printUtil} from "@/utils/print";
    import ItemTable from "@/components/Item/ItemTable.vue";
    import Select2 from 'v-select2-component'

    export default {
        name: "BudgetVarianceReport",
        components: {
            ItemTable,
            TableData,
            PulseLoader,
            Select2,

        },
        data() {
            return {
                appName: process.env.VUE_APP_NAME,
                loading: false,
                color: "#1ABB9C",
                size: "20px",
                month: [
                    "January",
                    "February",
                    "March",
                    "April",
                    "May",
                    "June",
                    "July",
                    "August",
                    "September",
                    "October",
                    "November",
                    "December",
                ],
                budgetVarianceForm: {
                    budget_head_id: "",
                    remarks: "",
                    document:'',
                    year: '',
                    month: '',
                    vessel_id: auth.getVesselId(),
                },
                isActive: "bg-secondary",
                vessel_name: "",
                budgetHeads: [],
                selectedYear: "",
                selectedMonth: "",
                budget_year: new Date().getFullYear(),
                budget_month: "",
                budget_head_name: "",
                budgetInfoList: [],
                years: [],
                myOptions: [],
                disable: false,
                vessel_id: auth.getVesselId(),
                formData:{
                  vessel_id: auth.getVesselId(),
                  budget_year: new Date().getFullYear(),
                  budget_month: '',
                  budget_head_id:'',
                },

            };
        },

        mounted() {
              this.formData.budget_month = this.month[new Date().getMonth()];
              this.yearsGenerate();
              this.veselInfo();
              this.getData();
              this.getBudgetHeadInfo();
        },

        methods: {
            yearsGenerate() {
                let i = new Date().getFullYear();
                for (i; i >= 2000; i--) {
                    this.years.push(i);
                }
            },


            createVarianceRemarks(budgetInfo) {
                this.budgetVarianceForm.budget_head_id = budgetInfo.id;
                this.budgetVarianceForm.year = this.selectedYear;
                this.budgetVarianceForm.month = this.selectedMonth;
                this.budget_head_name = budgetInfo.name;
                $('#budgetVarianceModal').modal('show')
            },


            storeVarianceRemarks: function (e) {
                e.preventDefault()
                this.disable = true;
                $('#budgetVarianceModal').modal('show')
                this.$http.post('/api/budget-variance-remarks', this.budgetVarianceForm).then(response => {
                    $('#budgetVarianceModal').modal('hide')
                    this.disable = false;
                    this.budgetVarianceForm.remarks = ''
                    this.budgetVarianceForm.document = ''
                    if (response.data.success) {
                        this.getData();
                        this.$snotify.success('Variance Remarks created successfully')
                    } else {
                        this.$snotify.error('Something went wrong try again later.')
                    }
                }).catch(e => {
                    this.disable = false;
                    let response = e.response
                    let status = e.response.status
                    if (status === 500) {
                        let msg = response.data.error
                        this.$snotify.error(msg)
                    }
                    if (status === 422) {
                        if (response.data?.errors) {
                            const errors = response.data.errors;
                            for (const key in errors) {
                                this.$snotify.error(errors[key][0])
                            }
                        }
                    }
                    if (status === 403) {
                        this.$snotify.warning(response?.data?.error)
                    }
                })
            },

          async getBudgetHeadInfo() {
            this.myOptions = [];
            var itemList = await this.$http.get('api/filter/budget-head/' + this.vessel_id);
            this.results = itemList.data.success;
            var newObj = {
              id: 0,
              text: 'All'
            };
            this.myOptions.push(newObj);
            this.results.filter(item => {
              var newObj = {
                id: item.id,
                text: item.name
              };
              this.myOptions.push(newObj)
            })
          },

          getData: function (e) {
            if (e !== undefined) {
              e.preventDefault()
            }
            this.loading = true;
            // if (this.formData.vessel) this.formData.vessel_id = this.formData.vessel.id
            let params = {
              vessel_id: this.formData.vessel_id,
              budget_year: this.formData.budget_year,
              budget_month: this.formData.budget_month,
              budget_head:this.formData.budget_head_id
            };
            this.selectedYear = this.formData.budget_year;
            this.selectedMonth = this.formData.budget_month;
            this.$http.get('/api/budget-report', {params}).then((response) => {
              this.loading = false;
              if (response.data) {
                this.budgetInfoList = response.data.success;
              }
            }).catch((error) => {
              console.log(error)

              this.loading = false;
              let response = error.response;
              if (response?.status === 403) {
                this.$snotify.warning(response?.data?.error)
              } else {

              }
            })
          },


            print(id, title = '') {
                printUtil(id, title)
            },
            veselInfo() {
                this.$http.get("/api/vessel/" + auth.getVesselId()).then((response) => {
                    this.vessel_name = response.data.success.name;
                }).catch((e) => {
                    console.log(e);
                });
            },

            isEmpty(obj) {
                if (obj.length < 1) {
                    return false;
                } else {
                    return true;
                }
            },
            goBack() {
                this.$router.go(-1);
            },
            convertDocument(event) {
              let file = event.target.files[0];
              this.budgetVarianceForm.document = file;
            },

        },
    };
</script>

<style scoped>
  /* .list-group{
      display: block !important;
  } */
  .x_title {
    border-bottom: none !important;
  }

  .tableStyle {
    max-height: 450px;
    overflow: auto;
  }
</style>
